// components/Onboarding.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import countImg from "../assets/count.png";
import payImg from "../assets/pay.png";
import checkoutImg from "../assets/checkout.png";

import "./Onboarding.css";
import eclipse from "../assets/splash-eclipse.png";

const screens = [
  {
    title: "Count",
    description: "Spot all the items you need and check your basket!",
    image: countImg,
  },
  {
    title: "Pay",
    description: "Secure and simple payment options.",
    image: payImg,
  },
  {
    title: "Checkout",
    description: "Fast and reliable checkout process.",
    image: checkoutImg,
  },
];

const Onboarding = () => {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (step < screens.length - 1) {
      setStep(step + 1);
    } else {
      finish();
    }
  };

  const finish = () => {
    localStorage.setItem("seenOnboarding", "true");
    navigate("/");
  };

  const { title, description, image } = screens[step];

  return (
    <div className="onboarding-container">
      {/* Eclipse background */}
      <img
        src={eclipse}
        alt="Background shape"
        className="onboarding-eclipse"
      />

      {/* Existing onboarding content goes here... */}
      <div className="h-screen flex flex-col justify-between bg-white p-6">
        {/* Image */}
        <div className="flex justify-center mt-16">
          <img src={image} alt={title} className="onboarding-image" />
        </div>

        {/* Progress dots */}
        <div className="flex justify-center mt-4 space-x-2">
          {screens.map((_, i) => (
            <div
              key={i}
              className={`w-3 h-3 rounded-full ${
                i === step ? "bg-purple-600" : "bg-gray-300"
              }`}
            />
          ))}
        </div>

        {/* Title & Description */}
        <div className="text-center mt-4 px-4">
          <h2 className="text-2xl font-bold text-purple-700 mb-2">{title}</h2>
          <p className="text-gray-700 text-sm">{description}</p>
        </div>

        {/* Buttons */}
        {/* Buttons - side by side */}
        <div className="button-group">
          <button onClick={handleNext} className="btn-continue">
            {step === screens.length - 1 ? "Finish" : "Continue"}
          </button>
          <button onClick={finish} className="btn-skip">
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
